
export const SpeakerIcon = ({ size = 24, color = "#55000C", strokeWidth = 2, className = "" }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path 
      d="M20 22H4V2H20V22Z" 
      stroke={color} 
      strokeWidth={strokeWidth}
    />
    <path 
      d="M8 14.0001C8 12.9392 8.42143 11.9218 9.17157 11.1717C9.92172 10.4215 10.9391 10.0001 12 10.0001C13.0609 10.0001 14.0783 10.4215 14.8284 11.1717C15.5786 11.9218 16 12.9392 16 14.0001C16 15.061 15.5786 16.0784 14.8284 16.8285C14.0783 17.5787 13.0609 18.0001 12 18.0001C10.9391 18.0001 9.92172 17.5787 9.17157 16.8285C8.42143 16.0784 8 15.061 8 14.0001ZM12 6.00009H11.996V5.99609H12V6.00009Z" 
      stroke={color} 
      strokeWidth={strokeWidth}
    />
  </svg>
);
